import * as React from 'react';
import { UserState } from 'app/reducers/state';
import { Callout, Intent, Spinner, H2, Divider } from '@blueprintjs/core';
import { executeQueryPutAuth } from 'app/utils/api';
import { StandardInput } from '../StandardInput';
import { LargeButton } from '../LargeButton';
import { NewPasswordDialog } from '../NewPasswordDialog';

interface Props {
    user: UserState;
};

interface State {
    waitingOnApi: boolean;
    firstName: string;
    lastName: string;
    gender: string;
    showChangePassword: boolean;
}

export class SettingsView extends React.Component<Props, State> {

    state: State = {
        waitingOnApi: false,
        firstName: "",
        lastName: "",
        gender: "",
        showChangePassword: false
    }

    componentDidMount() {
        this.setState({
            firstName: this.props.user.first,
            lastName: this.props.user.last,
            gender: this.props.user.gender
        });
    }

    handleUpdateUserPassword = (password: string) => {
        this.setState({
            waitingOnApi: true
        });

        const userUID = this.props.user.id;
        const userEmail = this.props.user.email;
        const userPassword = password;

        executeQueryPutAuth("users/" + userUID, {
            email: userEmail,
            password: userPassword,
            first: this.props.user.first,
            last: this.props.user.last,
            gender: this.props.user.gender
        }, this.props.user, (response) => {
            // Just re-load the page to apply it
            window.location.reload();
        });
    }

    handleUpdateUserSettings = () => {
        this.setState({
            waitingOnApi: true
        });

        const {
            lastName,
            firstName,
            gender
        } = this.state;

        const userUID = this.props.user.id;
        const userEmail = this.props.user.email;
        const userPassword = ""; // Optional

        executeQueryPutAuth("users/" + userUID, {
            email: userEmail,
            password: userPassword,
            first: firstName,
            last: lastName,
            gender: gender
        }, this.props.user, (response) => {
            // Just re-load the page to apply it
            window.location.reload();
        });
    }

	render() {
        const {
            waitingOnApi,
            firstName,
            lastName,
            gender,
            showChangePassword
        } = this.state;

        if (waitingOnApi) {
            return <Spinner />
        }

        return <span style={{display: 'block', width: '50%', margin: 'auto'}}>
            <NewPasswordDialog 
                user={this.props.user}
                isOpen={showChangePassword}
                onClose={() => { this.setState({showChangePassword: false})}}
                callback={(newPassword: string) => {
                    this.handleUpdateUserPassword(newPassword);
                }}
            />
            <Callout intent={Intent.NONE}>
                <H2>Profile Settings</H2>
                <br />

                <StandardInput
                    label={"First Name"}
                    type="text"
                    value={firstName}
                    onChange={(target) => {
                        this.setState({ firstName: target.target.value })
                    }}
                />

                <StandardInput
                    label={"Last Name"}
                    type="text"
                    value={lastName}
                    onChange={(target) => {
                        this.setState({ lastName: target.target.value })
                    }}
                />

                <StandardInput
                    label={"Your Voice Preference"}
                    type="dropdown"
                    value={gender}
                    options={[{value: 'male', label: 'Male'},{value: 'female', label: 'Female'}]}
                    onChange={(target) => {
                        this.setState({ gender: target.target.value })
                    }}
                />

                <LargeButton
                    text="Save Settings"
                    intent={Intent.SUCCESS}
                    onClick={() => {
                        this.handleUpdateUserSettings();
                    }}
                />

                <Divider />

                <LargeButton
                    text="Change Password"
                    intent={Intent.PRIMARY}
                    onClick={() => {
                        this.setState({
                            showChangePassword: true
                        });
                    }}
                />
            </Callout>
        </span>
	}
}
